/* HFS sizing-chart enhancements (sandbox). Runs only where .hfs-chart-modern exists. */
(function () {
  function init() {
    var pc = document.querySelector(".hfs-chart-modern");
    if (!pc) return;

    /* Pin the Contents nav (and anchor scroll offset) just below the real sticky
       header, auto-measured so it never cuts off "On this page". */
    var hdr = document.querySelector(".section-header");
    if (hdr) {
      var setStick = function () { document.documentElement.style.setProperty("--hfs-stick", (hdr.offsetHeight + 16) + "px"); };
      setStick();
      window.addEventListener("resize", setStick, { passive: true });
    }

    /* ---- 1. Ensure wide tables scroll horizontally (skip if already wrapped) ---- */
    pc.querySelectorAll("table.hoverTable").forEach(function (tbl) {
      if (!tbl.closest(".hfs-scroll") && !tbl.closest(".table")) {
        var w = document.createElement("div");
        w.className = "hfs-scroll";
        tbl.parentNode.insertBefore(w, tbl);
        w.appendChild(tbl);
      }
    });

    /* ---- 2. Map women's / men's tables by the most recent heading (document order,
             nesting-independent so wrappers like .table / .hfs-scroll don't matter) ---- */
    var tables = {}, womenHead = null, menHead = null, lastH2 = null;
    pc.querySelectorAll("h2, table.hoverTable").forEach(function (el) {
      if (el.tagName === "H2") { lastH2 = el; return; }
      var label = lastH2 ? lastH2.textContent.toLowerCase() : "";
      if (label.indexOf("women") > -1) { tables.women = el; womenHead = lastH2; }
      else if (label.indexOf("men") > -1) { tables.men = el; menHead = lastH2; }
    });

    /* ---- 3. Reorder: middle finder into the old shop-block slot; demote videos ---- */
    var heads = pc.querySelectorAll("h2"), getMost = null, videoH = null;
    heads.forEach(function (h) {
      var t = h.textContent.trim().toLowerCase();
      if (t === "video guides") videoH = h;
      if (t.indexOf("get the most") > -1) getMost = h;
    });
    var midFinder = document.getElementById("hfs-finder-middle");
    var shopBlock = pc.querySelector(".two_col-img");
    if (midFinder) {
      if (shopBlock) shopBlock.parentNode.insertBefore(midFinder, shopBlock);
      else if (getMost) getMost.parentNode.insertBefore(midFinder, getMost);
    }
    var bottomFinder = document.getElementById("hfs-finder-bottom");
    if (bottomFinder && tables.men) {
      var menWrap = tables.men.closest(".table") || tables.men.closest(".hfs-scroll") || tables.men;
      menWrap.parentNode.insertBefore(bottomFinder, menWrap.nextSibling);
    }
    if (videoH) {
      var grp = [videoH], n = videoH.nextElementSibling;
      while (n && n.tagName !== "H2") { grp.push(n); n = n.nextElementSibling; }
      grp.forEach(function (el) { pc.appendChild(el); });
    }

    /* ---- 4. Find My Width tool, built from the on-page tables ---- */
    var box = null;
    if (tables.women || tables.men) {
      box = buildWidthFinder(tables);
      pc.insertBefore(box, pc.firstChild);
      var howto = document.getElementById("how-to-measure");
      if (howto) box.parentNode.insertBefore(howto, box.nextSibling);
    }

    /* ---- 5. Anchors + sticky Contents nav ---- */
    var sections = [];
    function anchor(el, id, label) {
      if (!el) return;
      el.id = id; el.classList.add("hfs-anchor");
      sections.push({ id: id, label: label });
    }
    anchor(box, "find-my-width", "Find my width");
    anchor(document.getElementById("how-to-measure"), "how-to-measure", "How to measure");
    anchor(womenHead, "width-charts-women", "Women's width charts");
    anchor(menHead, "width-charts-men", "Men's width charts");

    var toc = document.getElementById("hfs-toc");
    if (toc && sections.length > 1) {
      var ul = toc.querySelector("ul");
      sections.forEach(function (s) {
        var li = document.createElement("li"), a = document.createElement("a");
        a.href = "#" + s.id; a.textContent = s.label; a.setAttribute("data-target", s.id);
        li.appendChild(a); ul.appendChild(li);
      });
      toc.hidden = false;
      var links = ul.querySelectorAll("a");
      function spy() {
        var stick = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--hfs-stick"), 10) || 130;
        var cur = sections[0].id;
        sections.forEach(function (s) {
          var el = document.getElementById(s.id);
          if (el && el.getBoundingClientRect().top <= stick + 6) cur = s.id;
        });
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) cur = sections[sections.length - 1].id;
        links.forEach(function (a) {
          a.classList.toggle("is-active", a.getAttribute("data-target") === cur);
        });
      }
      window.addEventListener("scroll", spy, { passive: true });
      window.addEventListener("resize", spy, { passive: true });
      spy();
    }
  }

  function buildWidthFinder(tables) {
    function parseFrac(txt) {
      txt = txt.replace(/["”]/g, "").trim();
      var m = txt.match(/(\d+)\s*(\d+)\s*[⁄\/]\s*(\d+)/);
      if (m) return parseInt(m[1], 10) + parseInt(m[2], 10) / parseInt(m[3], 10);
      var m2 = txt.match(/^(\d+(?:\.\d+)?)$/);
      if (m2) return parseFloat(m2[1]);
      var m3 = txt.match(/(\d+)\s*[⁄\/]\s*(\d+)/);
      if (m3) return parseInt(m3[1], 10) / parseInt(m3[2], 10);
      return NaN;
    }
    function widthCols(tbl) {
      var rows = tbl.querySelectorAll("tr");
      var top = rows[0].querySelectorAll("th"), bot = rows[1].querySelectorAll("th"), cols = [];
      for (var i = 1; i < top.length; i++) cols.push({ name: top[i].textContent.trim(), codes: bot[i] ? bot[i].textContent.trim() : "" });
      return cols;
    }
    function sizesFor(tbl) {
      var a = [];
      tbl.querySelectorAll("td.shoesize").forEach(function (td) { a.push(td.textContent.replace(/size/i, "").trim()); });
      return a;
    }
    /* Deep-link into the featured collection with Shopify native filters pre-applied
       (gender group-gid + raw size + raw width label). Verified against live data. */
    function shopLink(gender, name, size) {
      var BASE = "/collections/featured-orthopedic-styles-boots-sandals-more";
      var GENDER = { women: "125468964", men: "125501732" };
      var WIDTHMAP = {
        "super slim": "Narrow (2A/B)", "slim": "Narrow (2A/B)", "narrow": "Narrow (2A/B)",
        "medium": "Medium (B/D)", "wide": "Wide (D/E)", "extra wide": "Extra Wide (2E/3E)",
        "2x wide": "2X (4E)", "3x wide": "3X (6E)", "4x wide": "4X (8E)",
        "5x wide": "5X (10E)", "6x wide": "6X (12E)", "7x wide": "7X (14E)"
      };
      var params = [], g = GENDER[gender];
      if (g) params.push("filter.p.m.global.gender=" + encodeURIComponent("gid://shopify/FilterSettingGroup/" + g));
      if (size) params.push("filter.p.m.custom.size=" + encodeURIComponent(size));
      var wl = WIDTHMAP[(name || "").toLowerCase().trim()];
      if (wl) params.push("filter.p.m.custom.width=" + encodeURIComponent(wl));
      return params.length ? BASE + "?" + params.join("&") : BASE;
    }

    var box = document.createElement("div");
    box.className = "hfs-width-finder";
    box.innerHTML =
      '<h2 class="hfs-wf-title">Find Your Width in Seconds</h2>' +
      '<p class="hfs-wf-sub">No scrolling needed. Pick your size and enter your foot width, and we will tell you your width.<span class="hfs-wf-or" hidden> Or see your past sizes.</span></p>' +
      '<div class="hfs-wf-pastwrap" hidden>' +
        '<button type="button" class="hfs-wf-pasttoggle" aria-expanded="false">Your past sizes <span class="hfs-wf-count"></span> <span class="hfs-wf-caret">&#9662;</span></button>' +
        '<div class="hfs-wf-pastpanel" hidden><ul></ul></div>' +
      '</div>' +
      '<div class="hfs-wf-row">' +
      '<label>Shopping for<select id="hfs-wf-gender"></select></label>' +
      '<label>Your shoe size<select id="hfs-wf-size"></select></label>' +
      '<label>Foot width (inches)<input id="hfs-wf-measure" type="number" step="0.0625" min="2" max="7" placeholder="e.g. 4.25"></label>' +
      '<button type="button" id="hfs-wf-go">Find my width</button>' +
      "</div>" +
      '<div id="hfs-wf-result" class="hfs-wf-result" hidden></div>' +
      '<p class="hfs-wf-help">Need your measurement? See How to Measure Your Foot Width just below.</p>';

    var gSel = box.querySelector("#hfs-wf-gender"), sSel = box.querySelector("#hfs-wf-size");
    Object.keys(tables).forEach(function (g) {
      var o = document.createElement("option"); o.value = g; o.textContent = g === "women" ? "Women" : "Men"; gSel.appendChild(o);
    });
    function fillSizes() {
      sSel.innerHTML = "";
      sizesFor(tables[gSel.value]).forEach(function (s) { var o = document.createElement("option"); o.value = s; o.textContent = "Size " + s; sSel.appendChild(o); });
    }
    fillSizes();
    gSel.addEventListener("change", fillSizes);

    /* Logged-in customer's past sizes: pre-aim the tool + build an in-tool accordion */
    var past = document.getElementById("hfs-past");
    if (past) {
      function applyPick(g, s) {
        if ((g === "women" || g === "men") && tables[g]) { gSel.value = g; fillSizes(); }
        if (s) { for (var i = 0; i < sSel.options.length; i++) { if (sSel.options[i].value === s) { sSel.value = s; break; } } }
      }
      applyPick((past.getAttribute("data-gender") || "").toLowerCase(), (past.getAttribute("data-size") || "").trim());

      var items = past.querySelectorAll("li");
      if (items.length) {
        var pw = box.querySelector(".hfs-wf-pastwrap"), pul = box.querySelector(".hfs-wf-pastpanel ul");
        items.forEach(function (li) {
          var g = (li.getAttribute("data-gender") || "").toLowerCase(), s = (li.getAttribute("data-size") || "").trim();
          var item = document.createElement("li"), btn = document.createElement("button");
          btn.type = "button"; btn.className = "hfs-wf-pastitem"; btn.innerHTML = li.innerHTML;
          btn.addEventListener("click", function () {
            applyPick(g, s);
            var mi = box.querySelector("#hfs-wf-measure"); if (mi) mi.focus();
          });
          item.appendChild(btn); pul.appendChild(item);
        });
        box.querySelector(".hfs-wf-count").textContent = "(" + items.length + ")";
        pw.hidden = false;
        var orSpan = box.querySelector(".hfs-wf-or"); if (orSpan) orSpan.hidden = false;
        var toggle = box.querySelector(".hfs-wf-pasttoggle"), panel = box.querySelector(".hfs-wf-pastpanel"), caret = box.querySelector(".hfs-wf-caret");
        toggle.addEventListener("click", function () {
          if (panel.hasAttribute("hidden")) { panel.removeAttribute("hidden"); toggle.setAttribute("aria-expanded", "true"); caret.innerHTML = "&#9652;"; }
          else { panel.setAttribute("hidden", ""); toggle.setAttribute("aria-expanded", "false"); caret.innerHTML = "&#9662;"; }
        });
      }
    }

    box.querySelector("#hfs-wf-go").addEventListener("click", function () {
      var tbl = tables[gSel.value], size = sSel.value, measure = parseFloat(box.querySelector("#hfs-wf-measure").value);
      var res = box.querySelector("#hfs-wf-result");
      res.hidden = false;
      if (isNaN(measure)) { res.innerHTML = '<p class="hfs-wf-err">Please enter your foot width in inches (e.g. 4.25).</p>'; return; }
      var rowEl = null;
      tbl.querySelectorAll("tr.rowstyle").forEach(function (tr) {
        var sc = tr.querySelector("td.shoesize");
        if (sc && sc.textContent.replace(/size/i, "").trim() === size) rowEl = tr;
      });
      if (!rowEl) { res.innerHTML = '<p class="hfs-wf-err">Could not find that size.</p>'; return; }
      var cells = rowEl.querySelectorAll("td"), cols = widthCols(tbl), chosen = -1;
      for (var i = 1; i < cells.length; i++) {
        var v = parseFrac(cells[i].textContent);
        if (!isNaN(v) && v >= measure) { chosen = i - 1; break; }
      }
      if (chosen === -1) chosen = cols.length - 1;
      var w = cols[chosen], href = shopLink(gSel.value, w.name, size);
      var warn = (measure < 2.8125 || measure > 6.125)
        ? '<p class="hfs-wf-warn">That measurement looks unusual. Most foot widths fall between about 2 13/16 and 6 1/8 inches. Please double-check you measured straight across the widest part of your foot in inches. Here is our best estimate:</p>'
        : "";
      res.innerHTML = warn +
        '<div class="hfs-wf-resultrow">' +
          '<div class="hfs-wf-answer">Your width is likely <strong>' + w.name + "</strong>" +
          (w.codes ? ' <span class="hfs-wf-codes">(look for: ' + w.codes + ")</span>" : "") + "</div>" +
          '<a class="hfs-wf-cta" href="' + href + '">Shop Shoes in Your Size &rarr;</a>' +
        "</div>";
    });
    return box;
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
